import { Outlet, createFileRoute } from "@tanstack/react-router";

import { requireRole } from "@/lib/route-guards";

// 注: この layout は ADMIN ロールガードのみを担う「構造ルート」。
// あえて crumb を持たない。ダッシュボード (`/admin/`) はサイドナビ上の **兄弟 L1** であって
// 配下ページの祖先ではないため、ここに crumb を付けると全 admin ページが
// 「ダッシュボード › …」で始まる誤った階層表現になる。
export const Route = createFileRoute("/_authenticated/admin")({
  beforeLoad: requireRole("ADMIN"),
  component: () => <Outlet />,
});
